
import React, { useEffect, useState } from 'react'
import TutorSidebar from '../../../TutorSidebar/TutorSidebar'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getTimeSlotData } from '../../../../../Redux/action/MasterAction'
import Beatloader from '../../../../../Common/BeatLoader'
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import { Modal } from "react-bootstrap";
import moment from "moment-timezone";
import { jwtDecode } from "jwt-decode";
import { getTutorMyCourseBatchListData } from '../../../../../Redux/action/TutorAction'
import HourglassLoader from '../../../../../Common/HourglassLoader'
const host = process.env.REACT_APP_API_SERVER

const TutorUpdateBatch = () => {
    const authToken = localStorage.getItem('tutor-token');
    const decoded = jwtDecode(authToken);

    const userTimeZone = decoded?.user?.time_zone
    const todayLocal = moment().tz(userTimeZone).format("YYYY-MM-DD"); // Convert to local timezone

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const batchData = location?.state
    console.log('batchData', batchData)

    useEffect(() => {
        if (location) {
            if (!location?.state) navigate(-1);
        }
    }, [location?.state]);

    useEffect(() => {

        dispatch(getTimeSlotData(authToken));
    }, [])


    const {

        loadingTimeSlotDataListApi,
        TimeSlotDataListApiData,
        TimeSlotDataListApiError,

    } = useSelector(state => state?.MasterReducer);


    const [sessionData, setSessionData] = useState([]);


    let [initialValues, setInitialValues] = useState({
        course_id: "",
        batch_id: "",
        batch_name: "",
        batch_start_date: "",
        batch_end_date: "",
        max_no_of_student: "",
        time_slot_id: null,
        batch_session_data: [],
        firstSessionDate: "",
        firstSessionTime: "",
        firstSessionTopic: ""
    });

    useEffect(() => {
        if (batchData) {
            const sessions = (batchData?.batchesession || []).map((s, idx) => ({
                batch_start_date: s.batch_start_date,
                time_slot_id: String(s.time_slot_id),
                topic_details: s.topic_details || "",
                isExisting: true,
            }));

            setInitialValues({
                course_id: batchData.course_id,
                batch_id: batchData.id,
                batch_name: batchData.batch_name || "",
                batch_start_date: batchData.batch_start_date || "",
                batch_end_date: batchData.batch_end_date || "",
                max_no_of_student: batchData.max_no_of_student || "",
                time_slot_id: batchData.time_slot_id || "",
                firstSessionDate: sessions[0]?.batch_start_date || "",
                firstSessionTime: sessions[0]?.time_slot_id || "",
                firstSessionTopic: sessions[0]?.topic_details || "",
                batch_session_data: sessions
            });

            setSessionData(sessions);
        }
    }, [batchData]);



    const validationSchema = Yup.object().shape({

        batch_start_date: Yup.date().required("Start date is required"),

        batch_end_date: Yup.date()
            .required("End date is required")
            .min(
                Yup.ref("batch_start_date"),
                "End date must be greater than or equal to start date"
            ),
        batch_name: Yup.string().required("Batch name is required"),
        max_no_of_student: Yup.number().required("Max no. of student is required")
            .typeError("Max no. of student must be a number")

            .positive("Max no. of student must be greater than zero"),
    });

    const formik = useFormik({
        initialValues,
        enableReinitialize: true,   // 👈 reload values when batchData arrives
        validate: (values) => {
            const errors = {};

            if (!values.batch_name) errors.batch_name = "Batch name is required";
            if (!values.max_no_of_student) errors.max_no_of_student = "Max no. of student is required";
            if (!values.batch_start_date) errors.batch_start_date = "Start date is required";
            if (!values.batch_end_date) errors.batch_end_date = "End date is required";

            // Validate each session
            values.batch_session_data.forEach((session, index) => {
                if (!session.batch_start_date) {
                    errors[`batch_session_data[${index}].batch_start_date`] = "Session Start Date is required";
                }
                if (!session.time_slot_id) {
                    errors[`batch_session_data[${index}].time_slot_id`] = "Session Time is required";
                }
                if (!session.topic_details) {
                    errors[`batch_session_data[${index}].topic_details`] = "Topic is required";
                }
            });

            return errors;
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {

                const authToken = localStorage.getItem("tutor-token");
                let config = { headers: { "x-auth-token": authToken } };

                const res = await axios.post(`${host}/api/tutor/update-batch`, values, config);

                toast.success(res.data.message || "Batch updated successfully");
                navigate("/tutor/group-course-list");
            } catch (err) {
                toast.error(err.response?.data?.message || "Internal server error");
            } finally {
                setSubmitting(false);
            }
        }
    });



    const updateSessionData = (updatedSessions) => {
        setSessionData(updatedSessions);
        formik.setFieldValue("batch_session_data", updatedSessions);
    };

    const addSession = () => {
        const newSession = { batch_start_date: "", time_slot_id: "", topic_details: "", isExisting: false };
        updateSessionData([...sessionData, newSession]);
    };


    const deleteSession = (index) => {
        const updatedSessions = [...sessionData];
        updatedSessions.splice(index, 1);
        updateSessionData(updatedSessions);
    };




    const handleStartDateChange = (e) => {
        const value = e.target.value;
        formik.setFieldValue("firstSessionDate", value);

        const updatedSessions = [...sessionData];
        if (updatedSessions[0]) {
            updatedSessions[0].batch_start_date = value;
        } else {
            updatedSessions.push({ batch_start_date: value, time_slot_id: "", topic_details: "", isExisting: false });
        }
        updateSessionData(updatedSessions);
    };

    const handleTimeSlotChange = (e) => {
        const value = e.target.value;
        formik.setFieldValue("firstSessionTime", value);

        const updatedSessions = [...sessionData];
        if (updatedSessions[0]) {
            updatedSessions[0].time_slot_id = value;
        } else {
            updatedSessions.push({ batch_start_date: "", time_slot_id: value, topic_details: "", isExisting: false });
        }
        updateSessionData(updatedSessions);
    };




    return (
        <div>

            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;Group Course List
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {/* {loadingTutorMyCourseGroupBatchListApi ?
                                    <Beatloader />
                                    : */}
                                <form onSubmit={formik.handleSubmit}>
                                    <div className="add-new-course-sec">
                                        <h4 className="mb-4">Create New Batch</h4>
                                        <div className="row my-3">
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Batch Name<span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <input
                                                        type="text"
                                                        className="input-card-form"
                                                        placeholder="Enter Batch name"
                                                        name='batch_name'
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.batch_name}
                                                    />
                                                </div>
                                                {formik.errors.batch_name && (
                                                    <div className="text-danger">
                                                        {formik.errors.batch_name}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Max No. of Students<span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <input
                                                        type="number"
                                                        className="input-card-form"
                                                        placeholder="Number of students"
                                                        name='max_no_of_student'
                                                        min={1}
                                                        maxLength={4}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.max_no_of_student}
                                                    />
                                                </div>
                                                {formik.errors.max_no_of_student && (
                                                    <div className="text-danger">
                                                        {formik.errors.max_no_of_student}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Select Your Local Time Slot ({TimeSlotDataListApiData?.timeZoneAbb}) <span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <select className="select-form"
                                                        name="time_slot_id"
                                                        onChange={(e) => { formik.handleChange(e); handleTimeSlotChange(e) }}
                                                        onBlur={formik.handleBlur}
                                                        value={`${formik.values.time_slot_id}`}
                                                    >
                                                        <option value="">-Select-</option>
                                                        {
                                                            TimeSlotDataListApiData?.data?.map((data) => (
                                                                <option value={`${data?.id}`}>{data?.formated_start_time} - {data?.formated_end_time}</option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        Start Date (Assign Date)<span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <input type="date" className="input-card-form"
                                                        // min={todayLocal}
                                                        name='batch_start_date'
                                                        onChange={(e) => { formik.handleChange(e); handleStartDateChange(e) }}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.batch_start_date}
                                                    />
                                                </div>
                                                {formik.errors.batch_start_date && (
                                                    <div className="text-danger">
                                                        {formik.errors.batch_start_date}
                                                    </div>
                                                )}
                                            </div>
                                            <div className="col-lg-4 col-md-6">
                                                <div className="input-group">
                                                    <label htmlFor="" className="label">
                                                        End Date (Submit Date)<span className='text-danger'>*</span>
                                                    </label>
                                                    <br />
                                                    <input type="date" className="input-card-form" name='batch_end_date'
                                                        min={formik.values.batch_start_date}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        value={formik.values.batch_end_date} />
                                                </div>
                                                {formik.errors.batch_end_date && (
                                                    <div className="text-danger">
                                                        {formik.errors.batch_end_date}
                                                    </div>
                                                )}
                                            </div>
                                        </div>


                                        <div className="card bg-light">
                                            <div className="card-body">
                                                <div id="session-container">
                                                    <div

                                                        className="session mb-4"

                                                    >
                                                        <div className="row">
                                                            <div className="col-lg-10">
                                                                <h6 className="mb-3">Session-1</h6>
                                                            </div>
                                                            {/* Session Start Date */}
                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="input-group">
                                                                    <label className="label">Session Start Date<span className='text-danger'>*</span></label>
                                                                    <br />
                                                                    <input
                                                                        // min={todayLocal}
                                                                        type="date"
                                                                        className="input-card-form"
                                                                        name="firstSessionDate" id="city"
                                                                        readOnly
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        value={formik.values.firstSessionDate}

                                                                    />

                                                                </div>
                                                                {formik.errors.firstSessionDate && (
                                                                    <div className="text-danger">
                                                                        {formik.errors.firstSessionDate}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Session Start Time */}
                                                            <div className="col-lg-6 col-md-6">
                                                                <div className="input-group">
                                                                    <label className="label">Session Start Time ({TimeSlotDataListApiData?.timeZoneAbb}) <span className='text-danger'>*</span></label>
                                                                    <br />
                                                                    <select
                                                                        className="select-form"
                                                                        name="firstSessionTime" id="city"
                                                                        disabled
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        value={`${formik.values.firstSessionTime}`}

                                                                    >
                                                                        <option value="">-Select-</option>
                                                                        {
                                                                            TimeSlotDataListApiData?.data?.map((data) => (
                                                                                <option value={`${data?.id}`}>{data?.formated_start_time} - {data?.formated_end_time}</option>
                                                                            ))}
                                                                    </select>

                                                                </div>
                                                                {formik.errors.firstSessionTime && (
                                                                    <div className="text-danger">
                                                                        {formik.errors.firstSessionTime}
                                                                    </div>
                                                                )}
                                                            </div>

                                                            {/* Enter Topic Details */}
                                                            <div className="col-lg-12">
                                                                <div className="input-group">
                                                                    <label className="label">Enter Topic Details<span className='text-danger'>*</span></label>
                                                                    <br />
                                                                    <textarea
                                                                        className="input-card-form"
                                                                        name="firstSessionTopic" id="city"

                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        value={formik.values.firstSessionTopic}
                                                                    />

                                                                </div>
                                                                {formik.errors.firstSessionTopic && (
                                                                    <div className="text-danger">
                                                                        {formik.errors.firstSessionTopic}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {sessionData?.map((session, index) => (
                                                        index > 0 && (

                                                            <div key={index} className="session mb-4">
                                                                <div className="row">
                                                                    <div className="col-lg-10">
                                                                        <h6 className="mb-3">Session-{index + 1}</h6>
                                                                    </div>
                                                                    <div className="col-lg-2 d-flex justify-content-end">

                                                                        <div className="col-lg-2 d-flex justify-content-end">
                                                                            {!session.isExisting && (   // 👈 only show delete for new sessions
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-danger px-2 py-1"
                                                                                    onClick={() => deleteSession(index)}
                                                                                >
                                                                                    <i className="fa-solid fa-trash"></i>
                                                                                </button>
                                                                            )}
                                                                        </div>


                                                                    </div>

                                                                    {/* Session Start Date */}
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <div className="input-group">
                                                                            <label className="label">Session Start Date<span className='text-danger'>*</span></label>
                                                                            <br />
                                                                            <input
                                                                                min={formik.values.batch_start_date}
                                                                                max={formik.values.batch_end_date}
                                                                                type="date"
                                                                                className="input-card-form"
                                                                                name={`batch_session_data[${index}].batch_start_date`}
                                                                                value={session.batch_start_date}
                                                                                onChange={(e) => {
                                                                                    const updatedSessions = [...sessionData];
                                                                                    updatedSessions[index].batch_start_date =
                                                                                        e.target.value;
                                                                                    updateSessionData(updatedSessions);
                                                                                }}
                                                                                required
                                                                            />
                                                                            {formik.errors[`batch_session_data[${index}].batch_start_date`] && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors[`batch_session_data[${index}].batch_start_date`]}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* Session Start Time */}
                                                                    <div className="col-lg-6 col-md-6">
                                                                        <div className="input-group">
                                                                            <label className="label">Session Start Time ({TimeSlotDataListApiData?.timeZoneAbb}) <span className='text-danger'>*</span></label>
                                                                            <br />
                                                                            <select

                                                                                className="select-form"
                                                                                name={`batch_session_data[${index}].time_slot_id`}
                                                                                value={session.time_slot_id}
                                                                                onChange={(e) => {
                                                                                    const updatedSessions = [...sessionData];
                                                                                    updatedSessions[index].time_slot_id = e.target.value;
                                                                                    updateSessionData(updatedSessions);
                                                                                }}
                                                                                required
                                                                            >
                                                                                <option value="">-Select-</option>
                                                                                {/* Replace with your actual time slot data */}
                                                                                {
                                                                                    TimeSlotDataListApiData?.data?.map((data) => (
                                                                                        <option value={data?.id}>{data?.formated_start_time} - {data?.formated_end_time}</option>
                                                                                    ))}
                                                                            </select>
                                                                            {formik.errors[`batch_session_data[${index}].time_slot_id`] && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors[`batch_session_data[${index}].time_slot_id`]}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>

                                                                    {/* Topic Details */}
                                                                    <div className="col-lg-12">
                                                                        <div className="input-group">
                                                                            <label className="label">Enter Topic Details<span className='text-danger'>*</span></label>
                                                                            <br />
                                                                            <textarea
                                                                                className="input-card-form"
                                                                                name={`batch_session_data[${index}].topic_details`}
                                                                                placeholder="Topic Details"
                                                                                value={session.topic_details}
                                                                                onChange={(e) => {
                                                                                    const updatedSessions = [...sessionData];
                                                                                    updatedSessions[index].topic_details = e.target.value;
                                                                                    updateSessionData(updatedSessions);
                                                                                }}
                                                                                required
                                                                            />
                                                                            {formik.errors[`batch_session_data[${index}].topic_details`] && (
                                                                                <div className="text-danger">
                                                                                    {formik.errors[`batch_session_data[${index}].topic_details`]}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )))}


                                                    {/* Add Session Button at the End of Last Session */}
                                                    <div className="d-flex justify-content-end mt-2">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary px-2 py-1 add-session-btn"
                                                            onClick={addSession}
                                                        >
                                                            <i className="fa-solid fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <h6 className="text-primary mb-0 mt-4">
                                            Total Session&nbsp;
                                            <p
                                                className="fw-bold btn btn-primary mb-0"
                                                style={{ borderRadius: "50%", fontSize: 12, padding: "5px 10px" }}
                                            >
                                                {sessionData?.length}
                                            </p>
                                        </h6>
                                        <div className="row">
                                            <div className="col-lg-3 col-md-12">

                                                <button
                                                    type="submit"
                                                    disabled={formik.isSubmitting}
                                                    className="btn btn-primary fw-bold w-100 mb-4 mt-2"
                                                >
                                                    {formik.isSubmitting ? <HourglassLoader /> : 'Submit'}
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </form>
                                {/* } */}
                            </main>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default TutorUpdateBatch